import React from "react";
import { useStateValue } from "./../StateProveder/State";
import "./Checkout.css";
import CheckProduct from "./CheckProduct";
import chair from './../../utils/image/one.png'
const Checkout = () =>  {
  const [{ basket }] = useStateValue();

  return (
    <div className="checkout">
      <img className="checkout_add" src={chair}  alt="" />
      {basket?.length === 0 ? (
        <div className='checkout_empty'>
          <h2>Your shopping backet is empty</h2>
        </div>
      ) : (
        <div className='checkout_project'>
          <h2 className='checkout_title'>Your Shopping Bascket</h2>
          <div className='checkout_pro'>
          {basket.map( (item) => (
              <CheckProduct 
              id={item.id}
              title={item.title}
              image={item.image}
              price={item.price}
              rating={item.rating}
              
              />
          ))}
          </div>
        </div>
      )}
    </div>
  ); }

export default Checkout;
